import { CheckCircleIcon, WarningIcon } from '@phosphor-icons/react/dist/ssr';

export enum FeedbackType {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

export interface FeedbackConfig {
  backgroundColor: string;
  color: string;
  icon: React.ComponentType;
}

export interface FeedbackState {
  open: boolean;
  message: string;
  // Optional bold heading rendered above the message on its own line. When set,
  // the dialog stacks a bold title + regular body (Figma two-line toast, #820181);
  // when omitted, the message renders as the single bold line (unchanged).
  title?: string;
  type: FeedbackType;
  autoCloseDelay: number;
}

export interface FeedbackDialogContextType {
  open: boolean;
  message: string;
  title?: string;
  type: FeedbackType;
  config: FeedbackConfig;
  autoCloseDelay: number;
  handleDialogVisibility: (open: boolean) => void;
  showFeedbackDialog: (
    message: string,
    type: FeedbackType,
    autoCloseDelay?: number,
    title?: string,
  ) => void;
}

export const DEFAULT_AUTO_CLOSE_DELAY_MS = 3000;

export const feedbackConfig: Record<FeedbackType, FeedbackConfig> = {
  [FeedbackType.SUCCESS]: {
    backgroundColor: 'green.muted',
    color: 'green.pressed',
    icon: CheckCircleIcon,
  },
  [FeedbackType.WARNING]: {
    backgroundColor: 'orange.muted',
    color: 'orange.pressed',
    icon: WarningIcon,
  },
  [FeedbackType.ERROR]: {
    backgroundColor: 'red.muted',
    color: 'red.pressed',
    icon: WarningIcon,
  },
};
